import { RichTextRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathPickerContribution, MathRichTextPicker } from "../constants";

import { DefaultMathRichTextPicker } from "./richtext-picker";

let loadRichTextPick = !1;

export function bindRichTextMathPickerContribution(container) {
    loadRichTextPick || (loadRichTextPick = !0, container.bind(MathRichTextPicker).toDynamicValue((() => new DefaultMathRichTextPicker(resolveContainerBinding(container, RichTextRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathRichTextPicker));
}
//# sourceMappingURL=richtext-module.js.map
